/**
 * Golden ratio flex proportions for vertical content positioning.
 * Places content at ~38% from top instead of 50%, which looks optically balanced
 * due to the "gravity effect" where true-center content appears to sag.
 *
 * Usage: Apply as flex values on spacer elements above and below content
 * within a flex column container.
 */
export const GOLDEN_RATIO_TOP_FLEX = 382;
export const GOLDEN_RATIO_BOTTOM_FLEX = 618;
